var options = {
    strings: [
        "Cerca per marca",
        "Cerca per modello ",
        "Cerca per allestimento "
    ],
    typeSpeed: 60,
    backSpeed: 50,
    attr: "placeholder",
    smartBackspace: true,
    bindInputFocusEvents: true,
    loop: true,
};

/* typed.js scrive e cancella il placeholder in un ciclo infinito: lavoro continuo
   sul thread principale. Parte solo quando il campo e' davvero visibile (su mobile
   vive dentro il menu chiuso, e prima girava senza che nessuno lo vedesse), e la
   libreria arriva solo allora. */
const whenIdle = window.requestIdleCallback || ((callback) => setTimeout(callback, 200));

function startTyped(element) {
    whenIdle(() => {
        import("typed.js").then(({ default: Typed }) => new Typed(element, options));
    });
}

function startWhenVisible(element) {
    if (!element) {
        return;
    }
    if (!("IntersectionObserver" in window)) {
        startTyped(element);
        return;
    }

    // Un elemento in display:none non interseca mai: e' proprio quello che
    // vogliamo per il campo dentro il menu chiuso.
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                startTyped(entry.target);
            }
        });
    });
    observer.observe(element);
}

startWhenVisible(document.getElementById("searchtextdesktop"));
startWhenVisible(document.getElementById("searchtextmobile"));
